import { ColorPaletteType, ThemeColorsType, ThemeTailwindType } from 'src/domains/common/themeColors';

export const akbetsColors: ThemeTailwindType = {
    '--primary': '19 89% 48%',
    '--menu-primary': '0 0% 100%',
    '--menu-secondary': '0 0% 100%',
};

const colorPalette: ColorPaletteType = {
    primary: '#111111',
    secondary: '#e8530e',
    tertiary: '#5bbf21',
    dark: '#111111',
    shade1: '#242421',
    shade2: '#2c2c2a',
    shade3: '#333332',
    shade4: '#393939',
    shade5: '#575756',
    shade6: '#f4f4f4',
    textDark: '#111111',
    white: '#ffffff',
};

export const themeColors: ThemeColorsType = {
    header: {
        bgColor: colorPalette.dark,
        bgColorSecondary: colorPalette.primary,
        bgColorTertiary: colorPalette.secondary,
        bgColorQuaternary: colorPalette.secondary,

        borderColor: colorPalette.secondary,
        borderColorSecondary: colorPalette.secondary,

        txtColor: colorPalette.white,
        txtColorSecondary: colorPalette.secondary,
        txtColorTertiary: colorPalette.white,
        txtColorQuaternary: colorPalette.white,
    },
    buttons: {
        bgColor: colorPalette.secondary,
        txtColor: colorPalette.white,
    },
    input: {
        bgColor: colorPalette.shade6,
    },
    colorPicker: {
        colors: colorPalette,
        bgDefault: colorPalette.shade1,
        txtDefault: colorPalette.white,
    },
    anniversaryModal: {
        bgColor: '',
        bgColorSecondary: '',
        bgColorTertiary: '',
        txtColor: '',
        txtColorSecondary: '',
        txtColorTertiary: '',
    },
    loginPage: {
        bgColor: colorPalette.secondary,
    },
    traderChat: {
        bgColor: colorPalette.white,
        borderColor: '#d6e6f2',
        borderColorSecondary: '#ccc',
        txtColor: '#888',
    },
    compliancePopup: {
        bgColor: '#111111',
        txtColor: '#ffffff',
        bodyTxtColor: 'rgba(255, 255, 255, 0.8)',
        buttonBgColor: '#e8530e',
        buttonTxtColor: '#ffffff',
        secondaryBtnBgColor: 'rgba(255, 255, 255, 0.10)',
    },
};
